// Curated luxury imagery (France)
export const IMAGES = {
  heroParis: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=2000&q=80",
  heroRiviera: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&w=2000&q=80",
  provence: "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?auto=format&fit=crop&w=1600&q=80",
  jet: "/jet.png",
  villa: "/villa.png",
  champagne: "/champagne.png",
  yacht: "/yacht.png",
  chateau: "/chateau.png",
  chateauDinner: "/dinner.png",
  assistant: "/assistant2.png",
  perfume: "/perfume.png",
  louvre: "https://images.unsplash.com/photo-1541961017774-22349e4a1262?auto=format&fit=crop&w=1600&q=80",
  hotel: "/hotel.png",
  dining: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1600&q=80",
  riviera2: "https://images.unsplash.com/photo-1533105079780-92b9be482077?auto=format&fit=crop&w=1600&q=80",
  aboutSide: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=1200&q=80",
};

export const SERVICE_IMAGES = [
  "/villa.png", // Private Villas
  "/chateau.png", // Luxury Chateaux
  "/hotel.png", // Palaces & 5-Star Hotels
  "/jet.png", // Private Aviation
  "/chauffeur.png", // Luxury Chauffeurs
  "/yacht.png", // Yacht Charters
  "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=900&q=80", // Michelin Dining
  "https://images.unsplash.com/photo-1577219491135-ce391730fb2c?auto=format&fit=crop&w=900&q=80", // Private Chefs
  "https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?auto=format&fit=crop&w=900&q=80", // Wine Experiences
  "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=900&q=80", // Luxury Shopping
  "/helicopter.png", // Helicopter Tours
  "/family.png", // Family Luxury Travel
  "/security.png", // Personal Security
  "/bespoke.png", // Bespoke Requests
];

export const translations = {
  en: {
    nav: { about: "Maison", destinations: "Destinations", services: "Services", why: "Why Us", contact: "Inquire", tarifs: "Pricing", partners: "Partners", client: "Client Area" },
    hero: {
      eyebrow: "Miami · France",
      l1: "Europe,", l2: "Beyond Luxury.", l3: "Crafted Exclusively for You.",
      sub: "From the Mediterranean's most exclusive shores to the majestic Alps and beyond — bespoke European journeys crafted entirely around you.",
      cta1: "Start Your Journey", cta2: "Speak With a Private Concierge",
    },
    marquee: ["Private Villas", "Superyachts", "Château Dinners", "Private Aviation", "Michelin Tables", "After-Hours Louvre", "Champagne Houses", "Provence Estates"],
    about: {
      chapter: "Chapter I", title: "The Maison",
      lead: "A boutique concierge, born between Miami and France.",
      body: "French Touch Concierge is not a travel agency. We are the keepers of an address book that money cannot buy — a discreet maison crafting journeys for those for whom the ordinary was never an option. Every itinerary is written by hand, every door opened by name.",
      points: [
        { t: "French Expertise", d: "Native insiders across every region of France." },
        { t: "International Clientele", d: "Fluent in the expectations of the world's most discerning travelers." },
        { t: "Elite Network", d: "Relationships built over decades, never advertised." },
        { t: "Absolute Discretion", d: "Confidentiality is the first luxury we offer." },
      ],
    },
    services: {
      chapter: "Chapter II", title: "The Services",
      sub: "A single point of contact for an entire world of the extraordinary.",
      items: [
        "Private Villas", "Luxury Châteaux", "Palaces & Five-Star Hotels", "Private Aviation",
        "Luxury Chauffeurs", "Yacht Charters", "Michelin Dining", "Private Chefs",
        "Wine Experiences", "Luxury Shopping", "Helicopter Tours", "Family Luxury Travel",
        "Personal Security", "Bespoke Requests",
      ],
    },
    why: {
      chapter: "Chapter III", title: "Why French Touch",
      items: [
        { t: "Tailor-Made Itineraries", d: "Nothing pre-packaged. Everything composed for you." },
        { t: "Exclusive Local Network", d: "Doors that open only by name." },
        { t: "24/7 Concierge", d: "A dedicated concierge, always within reach." },
        { t: "Absolute Discretion", d: "Your privacy, protected without exception." },
        { t: "White-Glove Service", d: "Every logistic seamless, every detail perfected." },
        { t: "Elite Partnerships", d: "Palaces, houses and estates that trust us." },
      ],
      note: "For over twenty years, I served as personal assistant first to a government minister, then to the chairman of a multinational corporation. In those roles, no request was ever too unusual, too sensitive, or too impossible — I learned to anticipate every need long before it was spoken and to make the extraordinary feel effortless. French Touch Concierge is the distillation of that experience, placed entirely and discreetly at your service.",
      signature: "Édouard",
      signatureRole: "Founder & CEO, French Touch Concierge",
    },
    testimonials: {
      chapter: "Chapter IV", title: "In Their Words",
      items: [
        { q: "They arranged a château dinner that our family still speaks of years later. Flawless, from the first call to the last goodbye.", a: "Katherine V.", r: "Family Office, New York" },
        { q: "I travel for a living and I have never experienced this level of anticipation. They knew what I wanted before I did.", a: "Marcus D.", r: "CEO, Silicon Valley" },
        { q: "Discreet, elegant, impossibly well-connected. This is how France should be seen.", a: "Elizabeth R.", r: "Private Collector, Miami" },
      ],
    },
    contact: {
      chapter: "Chapter V", title: "Begin the Conversation",
      sub: "Share a few details. A private concierge will respond personally, in confidence.",
      f: { name: "Full Name", email: "Email", phone: "Phone", dates: "Travel Dates", guests: "Number of Guests", budget: "Estimated Budget", destinations: "Preferred Destinations", interests: "Interests", requests: "Special Requests" },
      budgets: ["$30,000 – $75,000", "$75,000 – $150,000", "$150,000 – $500,000", "$500,000+"],
      cta: "Let's Create Something Extraordinary",
      success: "Thank you. A private concierge will contact you shortly.",
      error: "Something went wrong. Please try again.",
    },
    footer: {
      tagline: "Bespoke luxury travel in France.",
      cols: { explore: "Explore", connect: "Connect" },
      links: { about: "Maison", services: "Services", contact: "Inquire" },
      legal: "Privacy Policy · Terms",
      rights: "All rights reserved.",
    },
  },
  fr: {
    nav: { about: "Maison", destinations: "Destinations", services: "Services", why: "Pourquoi Nous", contact: "Contact", tarifs: "Tarifs", partners: "Partenaires", client: "Espace Client" },
    hero: {
      eyebrow: "Miami · France",
      l1: "L'Europe,", l2: "Au-delà du Luxe.", l3: "Conçue Exclusivement pour Vous.",
      sub: "Des rivages les plus exclusifs de la Méditerranée aux cimes des Alpes et au-delà — des voyages européens sur mesure composés entièrement pour vous.",
      cta1: "Commencez le Voyage", cta2: "Parler à un Concierge Privé",
    },
    marquee: ["Villas Privées", "Superyachts", "Dîners au Château", "Aviation Privée", "Tables Étoilées", "Louvre Privatisé", "Maisons de Champagne", "Domaines de Provence"],
    about: {
      chapter: "Chapitre I", title: "La Maison",
      lead: "Une conciergerie de charme, née entre Miami et la France.",
      body: "French Touch Concierge n'est pas une agence de voyage. Nous sommes les gardiens d'un carnet d'adresses que l'argent ne peut acheter — une maison discrète qui compose des voyages pour ceux dont l'ordinaire n'a jamais été une option. Chaque itinéraire est écrit à la main, chaque porte ouverte par le nom.",
      points: [
        { t: "Expertise Française", d: "Des initiés locaux dans chaque région de France." },
        { t: "Clientèle Internationale", d: "À l'écoute des attentes des voyageurs les plus exigeants du monde entier." },
        { t: "Réseau d'Exception", d: "Des relations bâties sur des décennies." },
        { t: "Discrétion Absolue", d: "La confidentialité est notre premier luxe." },
      ],
    },
    services: {
      chapter: "Chapitre II", title: "Les Services",
      sub: "Un point de contact unique pour tout un monde d'extraordinaire.",
      items: [
        "Villas Privées", "Châteaux", "Palaces & Hôtels 5 Étoiles", "Aviation Privée",
        "Chauffeurs", "Charter de Yachts", "Tables Étoilées", "Chefs Privés",
        "Expériences Vinicoles", "Shopping Personnalisé", "Tours en Hélicoptère", "Voyages en Famille",
        "Sécurité Privée", "Demandes Sur Mesure",
      ],
    },
    why: {
      chapter: "Chapitre III", title: "Pourquoi French Touch",
      items: [
        { t: "Itinéraires Sur Mesure", d: "Rien de préfabriqué. Tout est composé pour vous." },
        { t: "Réseau Local Exclusif", d: "Des portes qui ne s'ouvrent que par le nom." },
        { t: "Conciergerie 24/7", d: "Un concierge dédié, toujours joignable." },
        { t: "Discrétion Absolue", d: "Votre vie privée, protégée sans exception." },
        { t: "Service d'Exception", d: "Chaque détail perfectionné, chaque logistique fluide." },
        { t: "Partenariats d'Élite", d: "Palaces, maisons et domaines qui nous font confiance." },
      ],
      note: "Pendant plus de vingt ans, j'ai été l'assistant personnel d'un ministre, puis du président d'une multinationale. Dans ces fonctions, aucune demande n'a jamais été trop insolite, trop sensible ou trop impossible — j'ai appris à anticiper chaque besoin bien avant qu'il ne soit exprimé et à rendre l'extraordinaire naturel. French Touch Concierge est la quintessence de cette expérience, mise entièrement et discrètement à votre service.",
      signature: "Édouard",
      signatureRole: "Fondateur & PDG, French Touch Concierge",
    },
    testimonials: {
      chapter: "Chapitre IV", title: "En Leurs Mots",
      items: [
        { q: "Ils ont organisé un dîner au château dont notre famille parle encore des années plus tard. Parfait, du premier appel au dernier au revoir.", a: "Katherine V.", r: "Family Office, New York" },
        { q: "Je voyage pour vivre et je n'ai jamais connu un tel niveau d'anticipation. Ils savaient ce que je voulais avant moi.", a: "Marcus D.", r: "PDG, Silicon Valley" },
        { q: "Discrets, élégants, incroyablement bien connectés. C'est ainsi que la France devrait se découvrir.", a: "Elizabeth R.", r: "Collectionneuse Privée, Miami" },
      ],
    },
    contact: {
      chapter: "Chapitre V", title: "Commençons la Conversation",
      sub: "Partagez quelques détails. Un concierge privé vous répondra personnellement.",
      f: { name: "Nom Complet", email: "Email", phone: "Téléphone", dates: "Dates de Voyage", guests: "Nombre d'Invités", budget: "Budget Estimé", destinations: "Destinations Préférées", interests: "Centres d'Intérêt", requests: "Demandes Spéciales" },
      budgets: ["30 000 $ – 75 000 $", "75 000 $ – 150 000 $", "150 000 $ – 500 000 $", "500 000 $+"],
      cta: "Créons Quelque Chose d'Extraordinaire",
      success: "Merci. Un concierge privé vous contactera sous peu.",
      error: "Une erreur s'est produite. Veuillez réessayer.",
    },
    footer: {
      tagline: "Voyages de luxe sur mesure en France.",
      cols: { explore: "Explorer", connect: "Nous Suivre" },
      links: { about: "Maison", services: "Services", contact: "Contact" },
      legal: "Confidentialité · Conditions",
      rights: "Tous droits réservés.",
    },
  },
};
